import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import VideoFeature from "@/components/VideoFeature";
import GalleryStrip from "@/components/GalleryStrip";
import ReviewsSection from "@/components/ReviewsSection";
import AwardsPartners from "@/components/AwardsPartners";
import { Seo } from "@/components/Seo";

export default function Home() {
    const location = useLocation();

    // Smooth-scroll to hash anchors (/#services, /#renovations, etc)
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
            }
        } else {
            window.scrollTo({ top: 0 });
        }
    }, [location]);

    return (
        <main data-testid="home-page">
            <Seo
                title="Custom Home Builder Central Coast NSW | Brazier Building & Design"
                description="Custom home builder on the Central Coast NSW. New builds, renovations, extensions, knockdown rebuilds and townhouse developments across the Central Coast, Newcastle & Sydney. 30+ years experience."
                path="/"
            />
            <Hero />
            <Services />
            <About />
            <VideoFeature />
            <GalleryStrip />
            <ReviewsSection />
            <AwardsPartners />
        </main>
    );
}
